import React from 'react';
import './MasterSection.css'; 

interface MasterSectionProps {
  backgroundImage: string;
  title: string;
  subtitle: string;
  actionText: string;
  onActionClick: () => void;
}

const MasterSection: React.FC<MasterSectionProps> = ({
  backgroundImage,
  title,
  subtitle,
  actionText,
  onActionClick,
}) => {
  return ( 
    <div className="master-cta-section">
      <div className="master-section-content">
         
        <div className="master-info"> 
          <p className="master-subtitle">{subtitle}</p>
          <h2 className="master-title">{title}</h2>
          
          <button className="master-action" onClick={onActionClick}>
            {actionText} →
          </button>
        </div>
      </div>
    </div>
  );
};

export default MasterSection;
